import React, { useState, useRef, useEffect } from "react";
import { ReportAPI } from "../../api/apiClient";
import {
  DailyProgressDprRow,
  DailyProgressDprResponse
} from "../../types/dailyProgressDpr";

export default function DailyProgressDprReport({
  projectId
}: {
  projectId: number;
}) {
  const [report, setReport] =
    useState<DailyProgressDprResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const requestIdRef = useRef(0);

  async function loadReport() {
    const currentRequestId = ++requestIdRef.current;

    try {
      setLoading(true);
      setReport(null);
      setSearched(true);

      const wbs = -1 * projectId;
      const data = await ReportAPI.getDailyProgressDpr(wbs, 3);

      if (currentRequestId !== requestIdRef.current) return;

      setReport(data ?? { heldUpWorks: [] });
    } catch (err) {
      if (currentRequestId !== requestIdRef.current) return;

      console.error(err);
      setReport({ heldUpWorks: [] });
      alert("Failed to load DPR report");
    } finally {
      if (currentRequestId === requestIdRef.current) setLoading(false);
    }
  }

  useEffect(() => {
    loadReport();
  }, [projectId]);

  return (
    <div className="bg-white rounded-xl shadow-sm border overflow-hidden">

      {/* ===== HEADER ===== */}
     {/* <div className="bg-blue-800 text-white font-semibold px-4 py-2 text-sm">*/} 
        <div className="bg-[#1788ac] text-white font-semibold px-4 py-2 text-sm">
        HELD UP WORKS
      </div>

      {/* ===== BODY ===== */}
      <div className="px-6 py-4">

        {loading && (
          <div className="text-center text-gray-500 py-6">
            Loading Held Up Works Report...
          </div>
        )}

        {!loading && searched && report && report.heldUpWorks.length === 0 && (
          <div className="text-center text-gray-400 py-6">
            No DPR entry available
          </div>
        )}

        {!loading && report && report.heldUpWorks.length > 0 && (
          <div>
            {report.heldUpWorks.map((row, index) => (
              <ProgressRow
                key={index}
                index={index + 1}
                row={row}
              />
            ))}
          </div>
        )}

      </div>
    </div>
  );
}

/* ---------------- ROW ---------------- */

function ProgressRow({
  row,
  index
}: {
  row: DailyProgressDprRow;
  index: number;
}) {
  const progress = Math.max(0, Math.min(100, row.progress));
  const remaining = 100 - progress;

  return (
    <div className="py-3">

      {/* TITLE + % */}
      <div className="flex justify-between text-[13px] mb-1">
        <span className="font-medium truncate pr-3">
          {String(index).padStart(2, "0")} {row.workName}
        </span>
        <span className="whitespace-nowrap">
          {progress.toFixed(2)}%
        </span>
      </div>

      {/* BAR */}
      <div className="relative w-full h-[10px] border border-gray-500 rounded-sm overflow-hidden">

        {/* COMPLETED */}
        <div
          className="absolute left-0 top-0 h-full bg-[#b8c4d2]"
          style={{ width: `${progress}%` }}
        />

        {/* REMAINING */}
        {remaining > 0 && (
          <div
            className="absolute right-0 top-0 h-full bg-[#ff8c00]"
            style={{ width: `${remaining}%` }}
          />
        )}
      </div>
    </div>
  );
}